interface PillarCardProps {
  icon: string;
  title: string;
  description: string;
  theme: "petroleo" | "white-dourado" | "white-petroleo" | "dourado";
  offsetY?: boolean;
}

export function PillarCard({
  icon,
  title,
  description,
  theme,
  offsetY = false,
}: PillarCardProps) {
  let cardClass = "p-8 rounded-xl text-center card-hover z-10 ";
  if (offsetY) {
    cardClass += "mt-0 sm:mt-12 ";
  }

  switch (theme) {
    case "petroleo":
      return (
        <div className={cardClass + "bg-petroleo text-white"}>
          <i className={`fa-solid ${icon} text-5xl text-dourado mb-6`}></i>
          <h4 className="font-titulo text-2xl mb-3">{title}</h4>
          <p className="text-sm text-gray-300 font-light">{description}</p>
        </div>
      );
    case "white-dourado":
      return (
        <div className={cardClass + "bg-white border border-gray-100 relative"}>
          <div className="absolute top-0 left-0 w-full h-1 bg-dourado rounded-t-xl"></div>
          <i className={`fa-solid ${icon} text-5xl text-petroleo mb-6`}></i>
          <h4 className="font-titulo text-2xl text-petroleo mb-3 font-bold">
            {title}
          </h4>
          <p className="text-sm text-gray-600 font-light">{description}</p>
        </div>
      );
    case "white-petroleo":
      return (
        <div className={cardClass + "bg-white border border-gray-100 relative"}>
          <div className="absolute top-0 left-0 w-full h-1 bg-petroleo rounded-t-xl"></div>
          <i className={`fa-solid ${icon} text-5xl text-petroleo mb-6`}></i>
          <h4 className="font-titulo text-2xl text-petroleo mb-3 font-bold">
            {title}
          </h4>
          <p className="text-sm text-gray-600 font-light">{description}</p>
        </div>
      );
    case "dourado":
      return (
        <div className={cardClass + "bg-dourado text-petroleo shadow-md"}>
          <i className={`fa-solid ${icon} text-5xl text-petroleo mb-6`}></i>
          <h4 className="font-titulo text-2xl text-petroleo mb-3 font-bold">
            {title}
          </h4>
          <p className="text-sm text-petroleo font-medium opacity-80">
            {description}
          </p>
        </div>
      );
  }
}
export default PillarCard;
